<template>
  <div class="actions">
    <Action v-for="(action, i) in actions" :key="i" :action="action"></Action>
    <div class="buttons">
      <button class="add" @click.prevent="addAction">Add action</button>
      <button class="save" @click.prevent="save">Save actions</button>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import Action from '@/components/preferences/Action'

@Component({
  name: 'Actions',
  props: ['actions'],
  components: { Action }
})
class Actions extends Vue {
  @Prop actions

  addAction() {
    this.actions.push({ prefix: '', action: '', suggest: '' })
  }

  save() {
    this.$fetch.put('/users/current/actions', this.actions).then(
      () => {
        this.errorMsg = 'saved'
      },
      (err) => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }
}

export default Actions
</script>

<style scoped lang="less">
.actions {
  display: flex;
  flex-direction: column;
}
.buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
